// extracted by mini-css-extract-plugin
module.exports = {"bottomDecoration":"HeaderMobile_bottomDecoration__bE0xl"};